import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useParams, useNavigate, generatePath } from "react-router-dom";
import Footer from "../Footer";
import BottomBarIcons from "../BottomBarIcons";
import { Statuses } from "../common/constant";
import useGetClientId from "../../hooks/useGetClientId";
import http from "../../api/server";
import {
  GET_PROPERTIES_AND_INSPECTORS_BY_CLIENT,
  UPSERT_NEW_INSPECTION,
  GET_ALL_INSPECTION_MASTER,
  UPDATE_DUPLICATE_INSPECTION_SETTINGS,
} from "../../api/apiPath";

import Header from "../Header";
import Sidebar from "../Sidebar";
import { Button } from "react-bootstrap";
import Select from "react-select";
import Toaster from "../common/Toaster";
import SidebarIcons from "../SidebarIcons";
import AutocompleteInput from "../common/AutocompleteInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LoadingComponent from "../common/LoadingComponent";
import ScheduleMini from "./ScheduleMini";
import DuplicateSettingsPopup from "./DuplicateSettingsPopup";

// import { sampleInspectorRows } from "../common/constant";
const FORMDATA = {
  propertyName: "",
  inspectionType: "",
  approvalDueDate: "",
};

const NewInspection = () => {
  const { userObj } = useSelector((state) => state.user);
  const { clientNameParam, inspectionMasterId } = useParams();
  const location = useLocation();

  const preselectedPropertyId = location.state?.propertyMasterId || null;
  const [formData, setFormData] = useState({
    ...FORMDATA,
    inspectionType: "Fire Door Survey",
  });
  const [scheduledInspectionDate, setScheduledInspectionDate] = useState(null);
  const [selectedInspectors, setSelectedInpsectors] = useState([]);
  const [errors, setErrors] = useState(FORMDATA);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [inspectorOptions, setInspectorOptions] = useState([]);
  const [cityInspectorOptions, setCityInspectorOptions] = useState([]);
  const [propertyInspectors, setPropertyInspectors] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  //eslint-disable-next-line no-unused-vars
  const [isScheduled, setIsScheduled] = useState(false);
  const [isDuplicateInspection, setIsDuplicateInspection] = useState(false);
  const isInspectorEditable =
    !inspectionMasterId || formData.status === Statuses.NEW;
  const [submitDisabled, setSubmitDisabled] = useState(
    Object.values(formData).some(
      (value) => value === "" || value === null || value === undefined,
    ) || selectedInspectors.length === 0,
  );
  const [error, setError] = useState(null);
  const [loading, setloading] = useState(true);
  // const today = new Date().toISOString().split("T")[0];
  const [showDuplicateSettingsPopup, setShowDuplicateSettingsPopup] =
    useState(false);
  const [lastInspectionData, setlastINspectionData] = useState({});
  const navigate = useNavigate();

  const clientObj = useGetClientId();

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  useEffect(() => {
    if (clientObj.clientId && userObj) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
      //setAllPropertyList(sampleInspectorRows);
    }
  }, [clientObj.clientId, clientObj.loading]);

  useEffect(() => {
    if (preselectedPropertyId && propertyOptions.length > 0) {
      const selectedSite = propertyOptions.find(
        (p) => p.propertyMasterId === preselectedPropertyId,
      );

      if (selectedSite) {
        handlePropertyChange(selectedSite);
      }
    }
  }, [preselectedPropertyId, propertyOptions]);

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_PROPERTIES_AND_INSPECTORS_BY_CLIENT +
          "?ClientId=" +
          clientId +
          "&loggedinUserEmail=" +
          userObj?.userEmail,
      );
      if (response.status === 200) {
        console.log("response.data", response?.data);
        const propertyList = response?.data?.properties;
        const sortedprops = [...propertyList].sort((a, b) =>
          String(a?.propertyName ?? "").localeCompare(
            String(b?.propertyName ?? ""),
            undefined,
            { sensitivity: "base" }, // case-insensitive
          ),
        );

        setPropertyOptions(sortedprops);
        const inspectorOptions = response?.data?.inspectors.map((i) => ({
          value: i.inspectorId,
          label: i.inspectorName,
          cityId: i.cityId,
        }));
        setInspectorOptions(inspectorOptions);
        setPropertyInspectors(response?.data?.propertyInspectors);

        if (inspectionMasterId) {
          await setEditInspectionData(inspectorOptions);
        } else {
          setIsScheduled(false);
        }
      }
    } catch (error) {
      return error;
    } finally {
      setloading(false);
    }
  };

  const setEditInspectionData = async (inspectorOptions) => {
    try {
      const response = await http.get(
        GET_ALL_INSPECTION_MASTER + "?ClientId=" + clientObj?.clientId,
      );
      console.log(response);
      if (response?.status === 200) {
        const editData = response?.data?.filter(
          (x) => x.inspectionMasterId == inspectionMasterId,
        );
        if (editData.length > 0) {
          if (editData[0]?.status === Statuses.COMPLETED) {
            setIsDuplicateInspection(true);
            setlastINspectionData(editData[0]);
            setIsScheduled(false);
            setFormData({
              ...formData,
              propertyName: editData[0].properties[0]?.propertyMasterId,
              inspectionType: editData[0].inspectionType,
              approvalDueDate: "",
              status: editData[0].status,
            });
            setScheduledInspectionDate("");

            const preinsp = editData[0].assignedInspectors.map((i) => ({
              value: i.inspectorId,
              label: i.inspectorName,
            }));
            setSelectedInpsectors(preinsp);
            const cityOptionsnew = getCityInspectorOptions(
              preinsp,
              editData[0].properties[0]?.cityId,
              inspectorOptions,
            );
            setCityInspectorOptions(cityOptionsnew);
          } else {
            setIsDuplicateInspection(false);
            if (editData[0]?.status === Statuses.NEW) {
              setIsScheduled(false);
            } else {
              setIsScheduled(true);
            }
            setFormData({
              ...formData,
              propertyName: editData[0].properties[0]?.propertyMasterId,
              inspectionType: editData[0].inspectionType,
              approvalDueDate: formatDateString(editData[0].approvalDueDate),
              status: editData[0].status,
            });
            setScheduledInspectionDate(editData[0].scheduledInspectionDate);

            const preinsp = editData[0].assignedInspectors.map((i) => ({
              value: i.inspectorId,
              label: i.inspectorName,
            }));
            setSelectedInpsectors(preinsp);
            const cityOptionsnew = getCityInspectorOptions(
              preinsp,
              editData[0].properties[0]?.cityId,
              inspectorOptions,
            );
            setCityInspectorOptions(cityOptionsnew);
          }
        }
      }
    } catch (error) {
      console.log(error);
      setError(error);
    }
  };

  const formatDateString = (dateString) => {
    const dateObj = new Date(dateString);
    if (!isNaN(dateObj)) {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedFormData = formData;

    if (name === "propertyName") {
      let preinsp = [];
      const selectedInsp = propertyInspectors.filter(
        (x) =>
          x.propertyMasterId === value &&
          x.inspectorId !== 0 &&
          x.inspectorName !== "",
      );
      console.log("sele", selectedInsp);
      if (value !== "" && selectedInsp.length !== 0) {
        updatedFormData = {
          ...formData,
          [name]: value,
          //   preDefinedInspector: selectedInsp[0].inspectorId,
        };
        preinsp = selectedInsp.map((i) => ({
          value: i.inspectorId,
          label: i.inspectorName,
        }));
      } else {
        updatedFormData = {
          ...formData,
          [name]: value,
          //   preDefinedInspector: "",
        };
        preinsp = [];
      }
      setSelectedInpsectors(preinsp);
      setErrors({
        ...errors,
        preDefinedInspector: "",
      });
    } else {
      updatedFormData = { ...formData, [name]: value };
    }

    handleDisableSave(updatedFormData, selectedInspectors);
    setFormData(updatedFormData);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  const handlePropertyChange = (site) => {
    let updatedFormData = formData;
    let preinsp = [];
    if (site != null) {
      const selectedInsp = propertyInspectors.filter(
        (x) =>
          x.propertyMasterId === site.propertyMasterId &&
          x.inspectorId !== 0 &&
          x.inspectorName !== "",
      );
      console.log("sele", selectedInsp, inspectorOptions);
      if (site.propertyMasterId !== "" && selectedInsp.length !== 0) {
        updatedFormData = {
          ...formData,
          propertyName: site.propertyMasterId,
          //   preDefinedInspector: selectedInsp[0].inspectorId,
        };

        preinsp = selectedInsp.map((i) => ({
          value: i.inspectorId,
          label: i.inspectorName,
          cityid: i.cityId,
        }));

        const cityOptionsnew = getCityInspectorOptions(preinsp, site.cityId);

        setCityInspectorOptions(cityOptionsnew);
      } else {
        updatedFormData = {
          ...formData,
          propertyName: site.propertyMasterId,
          //   preDefinedInspector: "",
        };
        preinsp = [];
        setCityInspectorOptions([]);
      }
    } else {
      updatedFormData = {
        ...formData,
        propertyName: "",
        //   preDefinedInspector: "",
      };
      preinsp = [];
      setCityInspectorOptions([]);
    }
    setSelectedInpsectors(preinsp);

    setErrors({
      ...errors,
      preDefinedInspector: "",
    });

    handleDisableSave(updatedFormData, selectedInspectors);
    setFormData(updatedFormData);
    setErrors((prevErrors) => ({
      ...prevErrors,
      propertyName: site ? "" : prevErrors.propertyName,
    }));
  };

  const getCityInspectorOptions = (preinsp, cityId, newinspectorOptions) => {
    const normalizeOption = (o) => ({
      value: o?.value ?? o?.inspectorId,
      label: o?.label ?? o?.inspectorName ?? "Unnamed",
      cityId: o?.cityId ?? o?.cityid, // accept both keys
    });
    const inspOpt = newinspectorOptions
      ? newinspectorOptions
      : inspectorOptions;
    const cityOptions = inspOpt
      .map(normalizeOption)
      .filter((ins) => Number(ins.cityId) === Number(cityId));

    const merged = [
      ...cityOptions.map(normalizeOption),
      ...preinsp.map(normalizeOption),
    ];

    const cityOptionsnew = Array.from(
      new Map(merged.map((o) => [String(o.value), o])).values(),
    );

    return cityOptionsnew;
  };

  const handleDisableSave = (data, inspector) => {
    setSubmitDisabled(
      Object.values(data).some(
        (value) => value === "" || value === null || value === undefined,
      ) || inspector.length === 0,
    );
  };

  //eslint-disable-next-line no-unused-vars
  const checkIsDuplicate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    //edit inspection only
    if (inspectionMasterId && !isDuplicateInspection) {
      handleSubmit();
      // setIsSubmitting(false);
      return;
    }
    //is duplicate -- show pop-up
    if (inspectionMasterId && isDuplicateInspection) {
      setShowDuplicateSettingsPopup(true);
      return;
    }
    //new inspection -- check if duplicate
    const selectedPropert = formData.propertyName;
    try {
      const response = await http.get(
        GET_ALL_INSPECTION_MASTER + "?ClientId=" + clientObj?.clientId,
      );
      if (response?.status === 200) {
        const tempArr = [];
        response?.data.map((inspection) => {
          const newObj = {
            id: inspection.inspectionMasterId,
            propertyMasterId: inspection.properties[0]?.propertyMasterId,
            propertyName: inspection.properties[0]?.propertyName,
            status: inspection.status,
            inspectionMasterId: inspection.inspectionMasterId,
            inspectionRefNumber: inspection.inspectionReferenceNumber,
          };
          tempArr.push(newObj);
        });
        const filteredProperties = tempArr?.filter(
          (x) => x.propertyMasterId === selectedPropert,
        );
        if (filteredProperties && filteredProperties.length > 0) {
          const onlyCompleted = filteredProperties?.filter(x => x.status === Statuses.COMPLETED);
          const sortedDesc = onlyCompleted?.sort(
            (a, b) => new Date(b.createdDate) - new Date(a.createdDate),
          );
          setlastINspectionData(sortedDesc?.[0]);

          const hasActive = filteredProperties.some(
            (item) =>
              item.status === Statuses.NEW ||
              item.status === Statuses.SCHEDULED ||
              item.status === Statuses.INPROGRESS ||
              item.status === Statuses.SUBMITTEDFORAPPROVAL ||
              item.status === Statuses.REJECTED,
          );
          if (hasActive) {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString:
                "An active inspection already exists for the selected property",
            });
            setIsSubmitting(false);
            return;
          } else {
            const hasAtLeastOneCompleted = filteredProperties.some(
              (item) => item.status === Statuses.COMPLETED,
            );

            const restAreCancelled = filteredProperties.every(
              (item) =>
                item.status === Statuses.COMPLETED ||
                item.status === Statuses.CANCELLED,
            );

            if (hasAtLeastOneCompleted && restAreCancelled) {
              setShowDuplicateSettingsPopup(true);
            } else {
              //new property inspection
              handleSubmit();
              // setIsSubmitting(false);
              return;
            }
          }
        } else {
          //new property inspection
          handleSubmit();
          // setIsSubmitting(false);
          return;
        }
      }
    } catch (err) {
      const errmsgg = error?.result?.message || "error getting inspection Data";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: errmsgg,
      });
      return;
    }
  };

  const handleSubmitPopup = async (settingData) => {
    setloading(true);
    setShowDuplicateSettingsPopup(false);
    try {
      const payload = {
        lastInspectionReferenceNumber: lastInspectionData?.inspectionRefNumber
          ? lastInspectionData?.inspectionRefNumber
          : lastInspectionData?.inspectionReferenceNumber,
        isDataRequired: settingData?.includeDetails,
        isImageRequired: settingData?.includeImages,
        loggedInUser: userObj?.userEmail,
      };
      const response = await http.post(
        UPDATE_DUPLICATE_INSPECTION_SETTINGS,
        payload,
      );
      if (response?.status === 200) {
        // handleSubmit();
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Inspection has been saved successfully.",
        });
        console.log(response);
        const result = response?.data?.result?.data;
        if (
          !inspectionMasterId ||
          (inspectionMasterId && isDuplicateInspection)
        ) {
          setTimeout(() => {
            result ? openEditScreen(result) : handleCancel();
          }, 2000);
        }
        // handleCancel();
        
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "error in submitting data, please try again",
        });
        setloading(false);
        setIsSubmitting(false);
      }
    } catch (err) {
      const errmsgg = error?.result?.message || "error submitting settings";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: errmsgg,
      });
      setloading(false);
      setIsSubmitting(false);
    }
  };

  const handlePopupCancel = () => {
    setShowDuplicateSettingsPopup(false);
    setIsSubmitting(false);
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.propertyName || formData.propertyName === "0")
      newErrors.propertyName = "Property Name is required";
    if (!formData.inspectionType || formData.inspectionType === "0")
      newErrors.inspectionType = "Inspection Type is required";
    if (!formData.approvalDueDate)
      newErrors.approvalDueDate = "Approval Due Date is required";
    if (!selectedInspectors || selectedInspectors.length === 0)
      newErrors.preDefinedInspector = "Inspector is required";
    return newErrors;
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      console.log("Form submitting...", formData);
      setIsSubmitting(true);
      const inspectorArray = selectedInspectors?.map((u) => u.value.toString());
      try {
        const payload = {
          inspectionMasterId: inspectionMasterId
            ? isDuplicateInspection
              ? 0
              : inspectionMasterId
            : 0,
          propertyMasterId: formData.propertyName,
          clientId: clientObj?.clientId,
          inspectionType: formData.inspectionType,
          approvalDueDate: formData.approvalDueDate,
          scheduledInspectionDate: inspectionMasterId
            ? isDuplicateInspection
              ? "2025-09-23T15:28:53.638Z"
              : scheduledInspectionDate
            : "2025-09-23T15:28:53.638Z",
          assignedInspectorsUserIds: inspectorArray,
          status: inspectionMasterId
            ? isDuplicateInspection
              ? "New"
              : formData.status
            : "New",
          createDate: new Date().toISOString(),
          createdByUserId: userObj?.userId,
          modifiedOn: new Date().toISOString(),
          modifiedByUserId: userObj?.userId,
          isActive: true,
          loggedInUserEmail: userObj?.userEmail,
        };

        await submitFormData(JSON.stringify(payload));
      } finally {
        setIsSubmitting(false);
        setloading(false);
      }
    }
  };

  const submitFormData = async (payload) => {
    try {
      const response = await http.post(UPSERT_NEW_INSPECTION, payload);
      if (response?.data?.result?.isSuccess === true) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Inspection has been saved successfully.",
        });
        const result = response?.data?.result?.data;
        if (
          !inspectionMasterId ||
          (inspectionMasterId && isDuplicateInspection)
        ) {
          setTimeout(() => {
            result ? openEditScreen(result) : handleCancel();
          }, 2000);
        }
        console.log(response);
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in saving data, please try again.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error.data.result.message);
      const errmsg =
        error.data.result.message ||
        "Active Inspection already exists for this property.";
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: errmsg,
      });
    }
  };
  const openEditScreen = (result) => {
    const pathTemplate =
      "/client/:clientNameParam/inspection/:inspectionMasterId";
    const params = {
      clientNameParam: clientNameParam,
      inspectionMasterId: result,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
    if (inspectionMasterId) {
      window.location.reload();
    }
  };

  const handleCancel = () => {
    navigate(
      generatePath("/client/:clientNameParam/inspectionDashboard", {
        clientNameParam,
      }),
    );
    // navigate(-1);
  };
  const handleReset = () => {
    setErrors(FORMDATA);
    setFormData({ ...FORMDATA, inspectionType: "Fire Door Survey" });
    setSelectedInpsectors([]);
    setSubmitDisabled(true);
  };

  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link
              to={generatePath("/client/:clientNameParam/", {
                clientNameParam,
              })}
            >
              Go back to Login
            </Link>
          </div>
        </div>
      </>
    );

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />

      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100">
            <div className="p-2 border-0 w-100">
              <div className="dashboard_header">
                <h2 className="mb-0">
                  {inspectionMasterId
                    ? isDuplicateInspection
                      ? "Duplicate Inspection"
                      : "Edit Inspection"
                    : "New Inspection"}
                </h2>
                <p className="header-description">
                  {inspectionMasterId
                    ? isDuplicateInspection
                      ? "Create duplicate for selected inspection"
                      : "Edit inspection for a property"
                    : "Create new inspection for a property"}
                </p>
              </div>
              <div className="resident-card px-2 pt-3 pb-4 mb-4">
                <div className="card-body-section px-3">
                  <div className="form-group">
                    <label htmlFor="propertyName">
                      Site Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <div
                      style={{
                        pointerEvents: preselectedPropertyId
                          ? "none"
                          : isDuplicateInspection || inspectionMasterId
                            ? "none"
                            : "auto",
                        opacity: preselectedPropertyId
                          ? 0.6
                          : isDuplicateInspection
                            ? 0.6
                            : 1,
                      }}
                    >
                      <AutocompleteInput
                        masterList={propertyOptions || []}
                        getOptionLabel={(c) => c?.propertyName || ""}
                        getOptionValue={(c) => c?.propertyMasterId || ""}
                        placeholder="Select Site"
                        inputClassName=""
                        wrapperClassName=""
                        notFoundText="Site not found"
                        className={
                          errors.propertyName
                            ? "input-error form-select"
                            : "form-select"
                        }
                        name="propertyName"
                        id="propertyName"
                        aria-label="Floating label select example"
                        value={formData.propertyName}
                        // disabled={isDuplicateInspection}
                        onValueChange={(value, site) => {
                          console.log("val", value, site);
                          handlePropertyChange(site);
                        }}
                      />
                    </div>
                    {errors.propertyName && (
                      <span className="formError">{errors.propertyName}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="inspectionType">
                      Inspection Type <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className={
                        errors.inspectionType
                          ? "input-error form-select"
                          : "form-select"
                      }
                      name="inspectionType"
                      id="inspectionType"
                      aria-label="Floating label select example"
                      value={formData.inspectionType}
                      disabled
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      {/* <option selected value="0">
                        Select Inspection Type
                      </option> */}

                      <option value="Fire Door Survey">Fire Door Survey</option>
                    </select>
                    {errors.inspectionType && (
                      <span className="formError">{errors.inspectionType}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="approvalDueDate">
                      Approval Target Date{" "}
                      <span style={{ color: "red" }}>*</span>
                      <i
                        className="bi bi-info-circle mt-0"
                        style={{
                          fontSize: "0.9rem",
                          marginLeft: "6px",
                          cursor: "pointer",
                          position: "relative",
                          top: "-3px",
                        }}
                        title="Expected date by which inspection should be approved."
                      ></i>
                    </label>
                    {/* <input
                      className={errors.approvalDueDate ? "input-error" : ""}
                      placeholder="Select approval target date"
                      id="approvalDueDate"
                      type="Date"
                      min={today}
                      name="approvalDueDate"
                      value={formData.approvalDueDate}
                      onChange={handleChange}
                    /> */}

                    <DatePicker
                      selected={
                        formData.approvalDueDate
                          ? new Date(formData.approvalDueDate)
                          : null
                      }
                      onChange={(date) =>
                        handleChange({
                          target: {
                            name: "approvalDueDate",
                            // value: date ? date.toISOString().split("T")[0] : "",
                            value: date
                              ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
                              : "",
                          },
                        })
                      }
                      dateFormat="MM-dd-yyyy"
                      minDate={new Date()}
                      placeholderText="Select approval target date"
                      className={errors.approvalDueDate ? "input-error" : ""}
                    />
                    {errors.approvalDueDate && (
                      <span className="formError mt-0">
                        {errors.approvalDueDate}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="floatingEmail">
                      Inspector(s) <span style={{ color: "red" }}>*</span>
                    </label>
                    {/* <Select
                      isMulti
                      options={cityInspectorOptions}
                      value={selectedInspectors}
                      className={
                        errors.preDefinedInspector ? "input-error" : ""
                      }
                      onChange={(e) => {
                        console.log("insp", selectedInspectors, e);
                        setSelectedInpsectors(e);
                        handleDisableSave(formData, e);
                        setErrors({
                          ...errors,
                          preDefinedInspector: "",
                        });
                      }}
                      name="preDefinedInspector"
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: "100%",
                          height: "2.81rem",
                        }),
                        control: (base) => ({
                          ...base,
                          minHeight: "2.81rem",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    /> */}
                    <Select
                      isMulti
                      options={cityInspectorOptions}
                      value={selectedInspectors}
                      // isDisabled={
                      //   inspectionMasterId !== null &&
                      //   inspectionMasterId !== undefined
                      // }
                      isDisabled={
                        !isInspectorEditable && !isDuplicateInspection
                      }
                      className={
                        errors.preDefinedInspector ? "input-error" : ""
                      }
                      onChange={(e) => {
                        setSelectedInpsectors(e);
                        handleDisableSave(formData, e);
                        setErrors({
                          ...errors,
                          preDefinedInspector: "",
                        });
                      }}
                      name="preDefinedInspector"
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: "100%",
                          height: "2.81rem",
                        }),
                        control: (base) => ({
                          ...base,
                          minHeight: "2.81rem",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    />

                    {errors.preDefinedInspector && (
                      <span className="formError mt-0">
                        {errors.preDefinedInspector}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="pb-3 button-group">
                <Button
                  type="reset"
                  className="col-12 col-sm-12 col-lg-2 col-md-3"
                  size="md"
                  variant={
                    inspectionMasterId !== null &&
                    inspectionMasterId !== undefined
                      ? "secondary"
                      : "tertiary"
                  }
                  onClick={handleCancel}
                  style={{ fontWeight: "600" }}
                >
                  Cancel
                </Button>

                {(inspectionMasterId === null ||
                  inspectionMasterId === undefined) && (
                  <Button
                    type="reset"
                    className="col-12 col-sm-12 col-lg-2 col-md-3"
                    size="md"
                    variant="secondary"
                    onClick={handleReset}
                    style={{ fontWeight: "600" }}
                  >
                    Reset
                  </Button>
                )}
                <Button
                  variant="primary"
                  size="md"
                  className="col-12 col-sm-12 col-lg-2 col-md-3"
                  active
                  type="submit"
                  // onClick={checkIsDuplicate} // duplicate inspection
                  onClick={handleSubmit}
                  style={{ fontWeight: "600" }}
                  disabled={isSubmitting || submitDisabled}
                >
                  {isSubmitting ? "Saving..." : "Save Inspection"}
                </Button>
              </div>
              {!isScheduled && inspectionMasterId && !isDuplicateInspection && (
                <ScheduleMini
                  inspectionMasterId={inspectionMasterId}
                  setToastData={setToastData}
                />
              )}
              {showDuplicateSettingsPopup && (
                <DuplicateSettingsPopup
                  onCancelPopup={handlePopupCancel}
                  OnSubmitPopup={handleSubmitPopup}
                />
              )}
            </div>
          </div>
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
      <Footer />
      <LoadingComponent loading={loading} />
    </>
  );
};

export default NewInspection;
